import { createSlice } from "@reduxjs/toolkit";
import ApiClientConnector from "src/api/ApiClientConnector";

const initialState = {
    countryList : []
};

export const CountryManagerSlice = createSlice({
    name: 'countries',
    initialState,
    reducers: {
        getCountries: (state, action) => {
            state.countryList  = action.payload;
        },
    }
})

export const { getCountries } = CountryManagerSlice.actions;

export const fetchCountries = (instance, accounts) => async (dispatch) => {
    const client = await ApiClientConnector(instance, accounts);
    const result = await client.countries.get();
    dispatch(getCountries(result));
    return result;
}

export default CountryManagerSlice.reducer;